import * as React from 'react';
import { useParams } from 'react-router-dom';
import { EventContextProvider } from '@/src/v2/components/EventContext';
import EventShell from './EventShell';
import useEventChrome from './useEventChrome';

/**
 * Event frame for v3 event sections: the event rail plus the shared event
 * data (activation, gallery, cached sessions/shares/media) the ported pages
 * read through useEventContext().
 */
export default function EventPage({ section, children }: { section: string; children: React.ReactNode }) {
    const { activationId } = useParams();
    const id = Number(activationId) || 0;
    const chrome = useEventChrome(id);
    return (
        <EventContextProvider activationId={id} key={id}>
            <EventShell
                orgInitials={chrome.orgInitials}
                orgLogo={chrome.orgLogo}
                eventName={chrome.eventName}
                eventSub={chrome.eventSub}
                live={chrome.live}
                quickLinks={chrome.quickLinks}
                nav={chrome.nav}
                activeSection={section}
            >
                {children}
            </EventShell>
        </EventContextProvider>
    );
}
